/** Validation patterns for forms */

export const NAME_PATTERN = '^[A-Za-z]+[ \\t]?[A-Za-z- ]+?[ \\t]*$';
export const EMAIL_PATTERN = '^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-z]{2,4}$';
